import React, { useState } from 'react';
import ErrorTips from '../errorTips';
import Announcement from '../announcement';
import Loading from '../loading';
import PrivacyAgreement from '../privacyAgreement/index'
import SiderBall from '../siderBall/index'
import Confirm from '../confirm'
import LoadingConfirm from '../loadingConfirm'
import WechatCode from '../wechatCode';
import WebGuide from '../webGuide';
import WechatGuide from '../wechatGuide';
import './index.css';
import { callApp, ACTION_CODE } from '../../utils/callApp';
import wx from 'weixin-js-sdk'
import WechatZdCode from '../wechatZdCode';
import VideoAD from '../videoAd'

const PAGE_NAME: { [key: string]: string | null } = {
  CLOSE: '',
  PAGREE: 'pAgree',
  ERRORTIPS: 'errortips',
  SIDERBALL: 'siderball',
  RELOAD: 'reload',
  LOADINGCONFIRM: 'loadingConfirm',
  LOADING: 'loading',
  Confirm: 'confirm',
  ANNOUNCEMENT: 'announcement',
  WECHATCODE: 'wechatCode',
  WECHATGUIDE: 'wechatGuide',
  WEBGUIDE: 'webGuide',
  ACCOUNTDATA: 'accountData',
  GETACCOUNTDATA: 'getAccountData',
  ISAGREE: 'isAgree',
  GETAGREE: 'getIsAgree',
  FORBIDDENSHARE:'forbiddenShare',
  MINIPROGRAMFORCETURN:'miniprogramForceTurn',
  MINIPROGRAMVIDEOAD: 'miniprogramVideoAd'
}

const AccountKey = 'passportAccountList'
window.addEventListener('message', (res) => {
  //判断res
  /* 
  {
    pageName:'xxxxx',
    pageData:'{xxxxxxx}'
  }
  */
  try {
    //解析
    console.log(res, 23232323)
    let data = JSON.parse(decodeURIComponent(window.atob(res.data)));
    if(data.pageName === PAGE_NAME.FORBIDDENSHARE){
      wx.hideOptionMenu();
      return;
    }
    if(data.pageName === PAGE_NAME.MINIPROGRAMVIDEOAD){
      const {pubAdOrderNo, adpid} = data.pageData
      if (wx?.miniProgram) {
        wx.miniProgram.navigateTo({
          url: `/pages/middlepage/index?pubAdOrderNo=${pubAdOrderNo}&adpid=${adpid}`
        })
        return
      }
      return
    }
    if (data.pageName === 'showVideoAd') {
      _setVideoAdInfo({
        visible: true,
        data: data.pageData
      })
      return
    }
    if (data.pageName === 'hideVideoAd') {
      _setVideoAdInfo({
        visible: false,
        data: data.pageData
      })
      return
    }
    if(data.pageName === ''){
      _setPageSign(PAGE_NAME.CLOSE);
      return
    }
    if (data.pageName) {
      if (data.pageName == PAGE_NAME.SIDERBALL) {
        _setBallInfo(data.pageData)
      } else if (data.pageName == PAGE_NAME.RELOAD) {
        window.location.reload();
      } else if (data.pageName === PAGE_NAME.ACCOUNTDATA) {
        window.localStorage.setItem(AccountKey, JSON.stringify(data.pageData))
      } else if (data.pageName === PAGE_NAME.GETACCOUNTDATA) {
        const localdata = JSON.parse(window.localStorage.getItem(AccountKey) ?? '[]')
        let iframe = document.getElementById('lvanIframe') as HTMLIFrameElement;
        if(iframe){
            //组装数据
            let _data = JSON.stringify({
              code: ACTION_CODE.POST_ACCOUNTDATA,
              data: localdata
            })
            iframe?.contentWindow?.postMessage(_data,'*');
        }
      } else if(data.pageName === PAGE_NAME.ISAGREE ){
          window.localStorage.setItem("isAgree", data.pageData)
      } else if(data.pageName === PAGE_NAME.GETAGREE){
        const localAgree = window.localStorage.getItem('isAgree') ?? '0'
        callApp(ACTION_CODE.POST_AGREE_STATUS,  {code: localAgree})
      } else {
        _setPageData(data.pageData || '')
        _setPageSign(data.pageName);
      }
    }
  } catch (e) {

  }
})
let _setBallInfo: any = null;
let _setPageData: any = null;
let _setPageSign: any = null;
let _setVideoAdInfo: any = null;
const Integration: React.FC = () => {

  const [pageSign, setPageSign] = useState<string | null>(null);
  const [pageData, setPageData] = useState<any>(null);
  const [ballInfo, setBallInfo] = useState<any>(null);
  const [videoAdInfo, setVideoAdInfo] = useState<{visible: boolean, data: any}>({visible: false, data: null});
  // let pageData:any = null;
  //监听
  _setBallInfo = setBallInfo;
  _setPageData = setPageData;
  _setPageSign = setPageSign;
  _setVideoAdInfo = setVideoAdInfo;
  const closePage = () => {
    
    setPageSign(PAGE_NAME.CLOSE);

  }
  const closeBall = () => {
    setBallInfo(null);
  }
  console.log(123131)
  const getPage = () => {
    switch (pageSign) {
      case PAGE_NAME.PAGREE:
        return <PrivacyAgreement onClose={closePage} data={pageData} />;
        break;
      case PAGE_NAME.ERRORTIPS:
        return <ErrorTips onClose={closePage} data={pageData} />;
        break;
      case PAGE_NAME.ANNOUNCEMENT:
        return <Announcement onClose={closePage} data={pageData} />;
        break;
      case PAGE_NAME.WECHATCODE:
        console.log("展示微信公众号二维码")
        return <WechatCode onClose={closePage} data={pageData} />
        break;
      case PAGE_NAME.WEBGUIDE:
        return <WebGuide />
        break;
      case PAGE_NAME.MINIPROGRAMFORCETURN:
        return <WechatZdCode onClose={closePage} url={pageData.forcedZdQr} canClose={pageData.forcedZdStatus}></WechatZdCode>
      case PAGE_NAME.WECHATGUIDE:
        return <WechatGuide />
        break;
      // case PAGE_NAME.LOADING:
      //   return <Loading onClose={closePage}  data={pageData}/>;
      //   break;
      // case PAGE_NAME.CONFIRM:
      //   return <Confirm onClose={closePage}  data={pageData}/>;
      //   break;
      case PAGE_NAME.LOADINGCONFIRM:
        return <LoadingConfirm onClose={closePage} data={pageData} />;
        break;
      default:
        break;
    }
  }
  const showBall = () => {
    if (ballInfo) {
      return <SiderBall onClose={closeBall} data={ballInfo} />
    }
  }
  //根据model获取页面展示信息
  return (
    <>
      {
        showBall()
      }
      {/* <Announcement onClose={()=>{}}  data={{announcementContext:'asdbasdfasdbasdfasdbasdfasdbasdfasdbasdfasdbasdfasdbasdfasdbasdfasdbasdfasdbasdfasdbasdf',announcementSupportOff:true}}/> */}
      {
        getPage()
      }
      <VideoAD visible={!!videoAdInfo?.visible} adInfo={videoAdInfo?.data?.adInfo} />
    </>
  );
}

export default Integration;
